import { AxiosError } from 'axios'

import { GENERAL_ERRORS_MESSAGES } from '@/constants'

export default function getGeneralErrorMessage(error: unknown) {
  if (error instanceof AxiosError) {
    const status = error.response?.status ?? error.status
    return (
      GENERAL_ERRORS_MESSAGES[`${status}_ERROR`] ||
      GENERAL_ERRORS_MESSAGES.DEFAULT_ERROR
    )
  }
  return GENERAL_ERRORS_MESSAGES.DEFAULT_ERROR
}
